<div style="width: 100%; text-align: center;">
    <div class="contentContainer" style="margin-top: 100px;">

        <h1 style="text-align: center;">PLEASE ENTER YOUR 6 DIGIT OTP</h1>

        <DIV class="appLabel">OTP</DIV>
        <input type="password" maxlength="6" class="appInput" name="txtPin" id="txtPin"
            style="width: 100px;text-align: center;" [(ngModel)]="req.Otp">
        <div *ngIf="showSubmitButton; else showprogress" class="appButtonBar">
            <input type="submit" class="appButton" name="cmdSubmit" id="cmdSubmit"
                style="width: 100px; margin-right: 50px;" (click)="onRetry()" value="RETRY">
            <input type="submit" class="appButton" name="cmdSubmit" id="cmdSubmit" style="width: 100px;"
                (click)="onOtpSubmit()" value="LOGIN">
        </div>
        <ng-template #showprogress>
            <DIV class="appLabel">Verifying, please wait...</DIV>
        </ng-template>
        <DIV class="appLabel" style="color: red;">{{this.errMessage}}</DIV>
    </div>
</div>